import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbIconModule, NbActionsModule, NbMenuModule, NbLayoutModule, NbUserModule, NbContextMenuModule } from '@nebular/theme';
import { HeaderComponent } from './components/header/header.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { GlobalSearchModule } from 'src/app/core/components/global-search/global-search.module';

@NgModule({
  declarations: [
    HeaderComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    NbLayoutModule,
    NbIconModule,
    NbActionsModule,
    NbMenuModule,
    NbContextMenuModule,
    GlobalSearchModule,
    NbUserModule
  ],
  exports: [
    HeaderComponent
  ]
})
export class NTXCoreModule { }
